import { render, staticRenderFns } from "./AssociatedApps.vue?vue&type=template&id=5b13f93a&scoped=true&"
import script from "./AssociatedApps.vue?vue&type=script&lang=js&"
export * from "./AssociatedApps.vue?vue&type=script&lang=js&"
import style0 from "./AssociatedApps.vue?vue&type=style&index=0&id=5b13f93a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b13f93a",
  null
  
)

export default component.exports